import {BooleanInput} from '@angular/cdk/coercion';
import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input,
    OnDestroy,
    OnInit,
    ViewEncapsulation
} from '@angular/core';
import {AngularFireAnalytics} from '@angular/fire/compat/analytics';
import {Router, RouterLink} from '@angular/router';
import {TranslocoModule} from '@ngneat/transloco';
import {AuthService} from '@shared/services/auth.service';
import {UserService} from 'app/core/user/user.service';
import {Subject, takeUntil} from 'rxjs';
import {User} from '../../../modules/admin/users/models/user.interface';
import {MatDividerModule} from '@angular/material/divider';
import {MatIconModule} from '@angular/material/icon';
import {NgClass, NgIf} from '@angular/common';
import {MatMenuModule} from '@angular/material/menu';
import {MatButtonModule} from '@angular/material/button';
import {provideTranslocoScope, TRANSLOCO_SCOPE} from "@ngneat/transloco";
import {PushNotificationsService} from "@shared/cloudMessaging/services/push-notifications.service";
import {clearSensitiveBrowserStorage} from '@shared/helpers/browser-storage';
@Component({
    selector: 'user',
    templateUrl: './user.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs: 'user'
    // providers: [provideTranslocoScope('layout_user')]
    ,
    standalone: true,
    imports: [TranslocoModule, MatButtonModule, MatMenuModule, NgIf, MatIconModule, NgClass, MatDividerModule, RouterLink],
    providers: [
      {provide: TRANSLOCO_SCOPE, useValue: 'layout'}
      // provideTranslocoScope('layoutuser')
  ],
})
export class UserComponent implements OnInit, OnDestroy {
  /* eslint-disable @typescript-eslint/naming-convention */
  static ngAcceptInputType_showAvatar: BooleanInput;
  /* eslint-enable @typescript-eslint/naming-convention */

  @Input() showAvatar: boolean = true;
  user: User;

  private _unsubscribeAll: Subject<any> = new Subject<any>();

  /**
   * Constructor
   */
  constructor(
    private _changeDetectorRef: ChangeDetectorRef,
    private analytics: AngularFireAnalytics,
    private _router: Router,
    private _userService: UserService,
    private _authService: AuthService,
    private _pushNotifications: PushNotificationsService
  ) {
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    // Subscribe to user changes
    this._authService.firestoreUser$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((user: User) => {
        this.user = user;

        // Mark for check
        this._changeDetectorRef.markForCheck();
      });
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Update the user status
   *
   * @param status
   */
  updateUserStatus(status: string): void {
    // Return if user is not available
    if (!this.user) {
      return;
    }

    // Update the user
    // this._userService.update({
    //     ...this.user,
    //     status
    // }).subscribe();
  }

  /**
   * Sign out
   */
  signOut(): void {
    console.log('jetzt aber sign out!');
    // Best effort: stop web push for this device while we are still authenticated
    this._pushNotifications.disable()
      .catch((err) => console.error('Error disabling push notifications on sign out: ', err))
      .then(() => this._authService.auth.signOut())
      // ASVS 6.6.1: signOut() clears the Firebase session from IndexedDB, but not what the
      // application wrote. Mail-derived drafts and finAPI tokens would otherwise survive logout.
      .then(() => clearSensitiveBrowserStorage())
      .then(() => this.analytics.logEvent('sign_out'))
      .then(() => this._authService.reInitSubscription())
      .then(() => this._router.navigate(['/abmelden']))
      .catch((err) => console.error('Error: ', err));
  }
}
